define('responsive-game-feed/app/scripts/utils/PitchUtils',[],function(){
	var PitchTypeDisplayEnum = {
		FA : "Fastball",
		FF : "4-Seam Fastball",
		FT : "2-Seam Fastball",
		FC : "Cutter",
		FO : "Forkball",
		FS : "Splitter",
		SI : "Sinker",
		SL : "Slider",
		CU : "Curveball",
		KC : "Knuckle Curve",
		SC : "Screwball",
		GY : "Gyroball",
		CH : "Changeup",
		KN : "Knuckleball",
		IN : "Int. Ball",
		PO : "Pitchout",
		UN : "Unknown",
		SN : "Unknown",
		AB : "Auto. Ball",
		AS : "Auto. Strike",
		NP : "No Pitch",
		EP : "Eephus",
		
		//SPANISH LANGUAGE PITCH TYPES
		FA_ES : "Recta",
		FF_ES : "Recta", //de cuatro costuras",
		FT_ES : "Recta", //de dos costuras",
		FC_ES : "Recta cortada",
		FO_ES : "Tenedor",
		FS_ES : "Recta de dedos separados",
		SI_ES : "Sinker",
		SL_ES : "Slider",
		CU_ES : "Curva",
		KC_ES : "Nudillo-Curva",
		SC_ES : "Tirabuzón",
		GY_ES : "Gyroball",
		CH_ES : "Cambio",
		KN_ES : "Nudillo",
		IN_ES : "Bola Intencional",
		PO_ES : "Bola Franca",
		UN_ES : "Desconocido",
		SN_ES : "Desconocido",
		AB_ES : "Bola Automática",
		AS_ES : "Strike Automático",
		NP_ES : "No Lanzamiento",
		EP_ES : "Globito"
		
	};
	var PitchUtils = {
		pitchData : {
			FA:{name:PitchTypeDisplayEnum.FA, color:"#BB0000", type:"Fastball", rgba: "rgba(187, 0, 0, ", typeColor:"#FF0000"},
			FF:{name:PitchTypeDisplayEnum.FF, color:"#BB0022", type:"Fastball", rgba: "rgba(187, 0, 34, ", typeColor:"#FF0000"},
			FT:{name:PitchTypeDisplayEnum.FT, color:"#BB0044", type:"Fastball", rgba: "rgba(187, 0, 68, ", typeColor:"#FF0000"},
			FC:{name:PitchTypeDisplayEnum.FC, color:"#990066", type:"Fastball", rgba: "rgba(153, 0, 102, ", typeColor:"#FF0000"},
			SI:{name:PitchTypeDisplayEnum.SI, color:"#BB0044", type:"Fastball", rgba: "rgba(187, 0, 68, ", typeColor:"#FF0000"}, 
			FS:{name:PitchTypeDisplayEnum.FS, color:"#770099", type:"Breaking", rgba: "rgba(119, 0, 153, ", typeColor:"#FF0000"},
			FO:{name:PitchTypeDisplayEnum.FO, color:"#770099", type:"Breaking", rgba: "rgba(119, 0, 153, ", typeColor:"#FF0000"}, 
			SL:{name:PitchTypeDisplayEnum.SL, color:"#0000FF", type:"Breaking", rgba: "rgba(0, 0, 255, ", typeColor:"#0000CC"},
			CU:{name:PitchTypeDisplayEnum.CU, color:"#0022FF", type:"Breaking", rgba: "rgba(0, 34, 255, ", typeColor:"#0000CC"},
			KC:{name:PitchTypeDisplayEnum.KC, color:"#0022FF", type:"Breaking", rgba: "rgba(0, 34, 255, ", typeColor:"#0000CC"}, 
			SC:{name:PitchTypeDisplayEnum.SC, color:"#99AB00", type:"Breaking", rgba: "rgba(143, 171, 0, ", typeColor:"#0000CC"},
			GY:{name:PitchTypeDisplayEnum.GY, color:"#99AB00", type:"Breaking", rgba: "rgba(143, 171, 0, ", typeColor:"#0000CC"},
			EP:{name:PitchTypeDisplayEnum.EP, color:"#99AB00", type:"Breaking", rgba: "rgba(143, 171, 0, ", typeColor:"#0000CC"},
			CH:{name:PitchTypeDisplayEnum.CH, color:"#0055FF", type:"Offspeed", rgba: "rgba(0, 85, 255, ", typeColor:"#68CFF9"},
			KN:{name:PitchTypeDisplayEnum.KN, color:"#0077FF", type:"Offspeed", rgba: "rgba(0, 119, 255, ", typeColor:"#68CFF9"},
			IN:{name:PitchTypeDisplayEnum.IN, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			PO:{name:PitchTypeDisplayEnum.PO, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			UN:{name:PitchTypeDisplayEnum.UN, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			SN:{name:PitchTypeDisplayEnum.SN, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			AB:{name:PitchTypeDisplayEnum.AB, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			AS:{name:PitchTypeDisplayEnum.AS, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"},
			NP:{name:PitchTypeDisplayEnum.NP, color:"#888899", type:"Neutral", rgba: "rgba(136, 136, 153, ", typeColor:"#999999"}
		},
		pitchIDs : ["FA", "FF", "FT", "FC", "FS", "FO", "SI", "SL", "CU", "KC", "SC", "EP", "GY", "CH", "KN", "IN", "PO", "UN", "AB", "AS", "SN", "NP"],
		getFullName : function(code) {
			return (this.pitchData[code]) ? this.pitchData[code].name : "";
		},
		getColor : function(code) {
			return (this.pitchData[code]) ? this.pitchData[code].color : "";
		},
		getTypeName : function(code) {
			return (this.pitchData[code]) ? this.pitchData[code].type : "";
		},
		getTypeColor : function(code) {
			return (this.pitchData[code]) ? this.pitchData[code].typeColor : "";
		},
		
		getTypeRBGA : function (code, alpha) {
			return (this.pitchData[code]) ? this.pitchData[code].rgba + alpha + ")" : "";
		},
		
		getID : function(name) {
			var id = "";
			for(var i=0,l=this.pitchIDs.length;i<l;i++) {
				if(this.pitchData[this.pitchIDs[i]].name == name) {
					id = this.pitchIDs[i];	
				}i
			}
			return id;
		},
		
		isPickoff : function (pitch) {
			var des = pitch.des.toLowerCase();
			return (des.indexOf("pickoff") >= 0);
		},
		
		is3Dpitch : function(pitch) {
			return (pitch.z0 >= 0);
		},
		
		timeAtYPos : function(pitch, yPos) {
			var d = pitch.y0 - yPos;
			var time1 = ((-1.0 * pitch.vy0) + Math.sqrt(pitch.vy0 * pitch.vy0 - 2 * pitch.ay*d)) / pitch.ay;
			var time2 = ((-1.0 * pitch.vy0) - Math.sqrt(pitch.vy0 * pitch.vy0 - 2 * pitch.ay*d)) / pitch.ay;
				  
			return Math.min(time1, time2);
		},
		
		xPosAtTime : function(pitch, time) {
			/*
			 * Solve for f(x) using the quadratic equation, 
			 * f(x) = ax^2 + bx + c
			 * to extract a point on the curve of the pitch
			 * x : the time from zero (when the pitch was thrown)
			 * a : the angular velocity of the ball
			 * b : the linear velocity of the ball
			 * c : the initial location the ball started at
			 */
			var 
				a = (0.5 * pitch.ax), //the angular velocity of the ball
				b = pitch.vx0, //the linear velocity of the ball
				c = pitch.x0, //the initial location the ball started at
				x = time, //the time from zero (when the pitch was thrown)
				xSquared = x * x,
				
				f_of_x = ( a * xSquared ) + (b*x) + c ; 
				
			return f_of_x  ;
		},
		
		yPosAtTime : function(pitch, time) {
			return pitch.y0 + (pitch.vy0 * time) + ((0.5 * pitch.ay) * (time * time));
		},
		
		zPosAtTime : function(pitch, time) {
			return pitch.z0 + (pitch.vz0 * time) + ((0.5 * pitch.az) * (time * time));
		},
		
		getPitchType : function(type) {
		  return PitchTypeDisplayEnum[type];
		}

	}

	return PitchUtils;
});
